const map = {
	"./de/dummies.json": 78528,
	"./en/dummies.json": 47752,
	"./es/dummies.json": 73856,
	"./fr/dummies.json": 13319,
	"./it/dummies.json": 94486,
	"./ja/dummies.json": 4150,
	"./nl/dummies.json": 46717,
	"./sv/dummies.json": 90150
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71030;